import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const LogoIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Document Crunch Logo Icon</title>;
    t1 = <path d="M0 0H6.98336C7.59954 0.636699 7.94186 1.00811 8.55804 1.62712V22.3729C7.94186 23.0096 7.58242 23.3633 6.98336 24H0V0ZM2.56741 2.22845V21.7892H5.99063V2.22845H2.56741Z" fill="currentColor" />;
    t2 = <path d="M10.8623 22.3729V1.62712L12.4367 0H18.0499L19.6244 1.62712V6.15475H17.0574V2.22845H13.4293V21.7892H17.0574V17.3854H19.6244V22.3729L18.0499 24H12.4367C11.8207 23.381 11.4784 23.0096 10.8623 22.3729Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};